<template>
  <div class="case base">
    <inside-header :title="`我的收藏(${list.length})`" back-link-name="UserIndex" />
    <div class="main">
      <van-empty v-if="list.length === 0" description="你还没有关注教员哟~" />
      <div v-else class="list">
        <div v-for="(item, index) in list" :key="index" class="item">
          <a-row :gutter="8" type="flex" justify="space-between" align="middle">
            <a-col :span="5">
              <img class="header-img" :src="item.avatar" alt="">
            </a-col>
            <a-col :span="13">
              <div class="teacher-info">
                <span class="nick-name">{{ item.nick_name }}</span>
                <span class="code">T{{ item.id }}</span>
              </div>
              <div class="tags">
                <span class="tag">{{ item.school }}</span>
                <!-- <span class="tag">{{ item.major }}</span> -->
              </div>
              <div class="subjects">
                <span class="subject">{{ item.personal_sign }}</span>
              </div>
            </a-col>
            <a-col :span="6" class="button-area">
              <van-button type="default" size="small" round icon="success" @click="onHaveAttention(item.id)">
                已关注
              </van-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'CourseArrangement',
  components: {
    InsideHeader
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http({
        url: 'index/user/focusTeacherList',
        method: 'get'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          this.list = res.data.focus_teacher_list
        }
      })
    },
    onHaveAttention(id) {
      this.$http({
        url: 'index/user/focusTeacherCancel',
        method: 'post',
        data: {
          teacher_id: id
        }
      }).then(res => {
        if (res.status === 'success') {
          this.loadData()
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .main {
    padding: 10px;
  }
  .list {
    .item {
      padding: 15px;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
      margin-bottom: 10px;

      .header-img {
        height: 60px;
        width: 60px;
        border-radius: 50%;
      }

      .teacher-info {
        .nick-name {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          line-height: 16px;
          color: #333333;
        }

        .code {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          color: #ff5c00;
          margin-left: 10px;
        }
      }

      .tags {
        margin-top: 3px;
        .tag {
          padding: 2px 5px;
          border-radius: 5px;
          display: inline-block;
          font-family: PingFang-SC-Regular;
          font-size: 11px;
          line-height: 16px;
          color: #666666;
          background-color: #f2f4f4;
          margin-right: 10px;
        }
      }

      .subjects {
        margin-top: 2px;
        .subject {
          font-family: PingFang-SC-Regular;
          font-size: 11px;
          line-height: 19px;
          color: #666666;
          margin-right: 10px;
        }
      }

      .button-area {
        button {
          color: #666666;
        }
      }
    }
  }
</style>
